import { render, staticRenderFns } from "./form-list-card.vue?vue&type=template&id=6ce2e86d&"
import script from "./form-list-card.vue?vue&type=script&lang=js&"
export * from "./form-list-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports